/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomField model module.
 * @module model/CustomField
 * @version v1
 */
class CustomField {
    /**
     * Constructs a new <code>CustomField</code>.
     * @alias module:model/CustomField
     * @param customFieldId {Number} 
     * @param customFieldType {Number} 
     * @param customFieldCompulsory {Boolean} 
     */
    constructor(customFieldId, customFieldType, customFieldCompulsory) { 
        
        CustomField.initialize(this, customFieldId, customFieldType, customFieldCompulsory);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, customFieldId, customFieldType, customFieldCompulsory) { 
        obj['CustomFieldId'] = customFieldId;
        obj['CustomFieldType'] = customFieldType;
        obj['CustomFieldCompulsory'] = customFieldCompulsory;
    }

    /**
     * Constructs a <code>CustomField</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomField} obj Optional instance to populate.
     * @return {module:model/CustomField} The populated <code>CustomField</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomField();

            if (data.hasOwnProperty('CustomFieldId')) {
                obj['CustomFieldId'] = ApiClient.convertToType(data['CustomFieldId'], 'Number');
            }
            if (data.hasOwnProperty('CustomFieldText')) {
                obj['CustomFieldText'] = ApiClient.convertToType(data['CustomFieldText'], 'String');
            }
            if (data.hasOwnProperty('CustomFieldType')) {
                obj['CustomFieldType'] = ApiClient.convertToType(data['CustomFieldType'], 'Number');
            }
            if (data.hasOwnProperty('CustomFieldCompulsory')) {
                obj['CustomFieldCompulsory'] = ApiClient.convertToType(data['CustomFieldCompulsory'], 'Boolean');
            }
            if (data.hasOwnProperty('CustomFieldAnswer')) {
                obj['CustomFieldAnswer'] = ApiClient.convertToType(data['CustomFieldAnswer'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomField</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomField</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomField.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['CustomFieldText'] && !(typeof data['CustomFieldText'] === 'string' || data['CustomFieldText'] instanceof String)) {
            throw new Error("Expected the field `CustomFieldText` to be a primitive type in the JSON string but got " + data['CustomFieldText']);
        }
        // ensure the json data is a string
        if (data['CustomFieldAnswer'] && !(typeof data['CustomFieldAnswer'] === 'string' || data['CustomFieldAnswer'] instanceof String)) {
            throw new Error("Expected the field `CustomFieldAnswer` to be a primitive type in the JSON string but got " + data['CustomFieldAnswer']);
        }

        return true;
    }


}

CustomField.RequiredProperties = ["CustomFieldId", "CustomFieldType", "CustomFieldCompulsory"];

/**
 * @member {Number} CustomFieldId
 */
CustomField.prototype['CustomFieldId'] = undefined;

/**
 * MaxLength:1000
 * @member {String} CustomFieldText
 */
CustomField.prototype['CustomFieldText'] = undefined;

/**
 * @member {Number} CustomFieldType
 */
CustomField.prototype['CustomFieldType'] = undefined;

/**
 * @member {Boolean} CustomFieldCompulsory
 */
CustomField.prototype['CustomFieldCompulsory'] = undefined;

/**
 * MaxLength:500
 * @member {String} CustomFieldAnswer
 */
CustomField.prototype['CustomFieldAnswer'] = undefined;






export default CustomField;

